module.exports = __webpack_public_path__ + "img/honer12.bb5c09bf.jpg";